/// <reference path="../../../app.definition.ts" />

interface IEcvFixedChoicesScope extends ng.IScope {
    showFixed: boolean;
}

function ecvFixedChoices($timeout: ng.ITimeoutService, $compile: ng.ICompileService): ng.IDirective {
    return {
        restrict: 'A',
        require: 'uiSelect',
        replace: false,
        scope: false,
        link: (scope: IEcvFixedChoicesScope, element, attributes: ng.IAttributes, $select): void => {
            const fixedChoices = element.parent().find('.ecv-fixed-choice');

            scope.showFixed = false;


            $timeout(() => {
                let elClone = fixedChoices.clone();
                element.append($compile(elClone)(scope));
                scope.$watch(() => {
                    return $select.open;
                }, function (newVal, oldVal) {
                    if (!!newVal) {
                        $timeout(() => {
                            let selectChoices = element.find('.ui-select-choices');
                            element.find('.ecv-fixed-choice').css({
                                'top': element.height() + selectChoices.outerHeight() - 2
                            });
                            scope.showFixed = true;
                        }, 1);
                    }
                });

                scope.$watch(() => {
                    return $select.search;
                }, function (newVal, oldVal) {
                    if (!!$select.open) {
                        scope.showFixed = $select.items.length > 0; let selectChoices = element.find('.ui-select-choices');
                        $timeout(() => {
                            element.find('.ecv-fixed-choice').css({
                                'top': element.height() + selectChoices.outerHeight() - 2
                            });
                        }, 1);
                        //element.find('.ecv-fixed-choice').css({ 'display': ($select.items.length > 0) ? 'block !important' : 'none' });
                    };
                });

            }, 1);
        }
    };
}

angular.module('eCareVault.common.directives').directive('ecvFixedChoices', ['$timeout', '$compile', ecvFixedChoices]);